import React from "react";


import APPLICATION_THEME_SETTINGS, {APPLICATION_THEME_SETTINGS_TYPE} from "@DATA/Theme";


export const ApplicationThemeContext = React.createContext<APPLICATION_THEME_SETTINGS_TYPE | null>(null);


export {
    APPLICATION_THEME_SETTINGS
};


export default ApplicationThemeContext;
